import React from "react";
import { Grid, GridItem } from "@chakra-ui/react";

export enum Variant {
  SMALL,
  LARGE
}

const VariantProperties = {
  [Variant.SMALL]: {
    color: "gray.100",
    fontSize: "18px",
    areas: "'label' 'text'"
  },
  [Variant.LARGE]: {
    color: "blue.500",
    fontSize: "33px",
    areas: "'text' 'label'"
  }
};

interface ProfileTextProps {
  label: string;
  text: string;
  variant: Variant;
}

const ProfileText: React.FC<ProfileTextProps> = ({
  label,
  text,
  variant = Variant.SMALL
}: ProfileTextProps) => {
  return (
    <Grid
      gap={0}
      gridTemplateColumns="auto"
      gridTemplateRows="auto auto"
      templateAreas={VariantProperties[variant].areas}
    >
      <GridItem color="gray.100" fontSize="sm" gridArea="label">
        {label}
      </GridItem>
      <GridItem
        fontSize={VariantProperties[variant].fontSize}
        color={VariantProperties[variant].color}
        gridArea="text"
        wordBreak="break-word"
      >
        {text}
      </GridItem>
    </Grid>
  );
};

export default ProfileText;
